/**
 * Created by kb on 2017/11/17.
 */
import  { menuPage } from  '@/commonJs/commonconf'
import  { util } from  '@/commonJs/util'

//根据当前路由地址映射界面权限编码
const  mappingMenuPage=function (path) {
  let leftMenus = window.sessionStorage.getItem('leftMenus');
  leftMenus && (leftMenus = JSON.parse(leftMenus));
  if (leftMenus && leftMenus.constructor === Array) {
    menuPage.pageCode = "";
    menuPage.pid = "";
    menuPage.pageLevel = -1;
    leftMenus.findMenuCodeByPath(path, menuPage);
    if (menuPage.pageLevel > 3) {
      menuPage.pageCode = "";
      util.findParentPage(leftMenus, menuPage, leftMenus);
    }
  }
}

export { mappingMenuPage }



// WEBPACK FOOTER //
// ./src/commonJs/objExtend/permission.js